<template>
    <div id="head">
        <Header @change="idxChange"></Header>
        <router-view style="margin-top:.8rem" ref="aa"></router-view>
        <Bottom></Bottom>
        <!--      <div class="box">-->
        <!--          <a href="tencent://message/?uin=37378528">-->
        <!--              <div class="qq">-->
        <!--                  &lt;!&ndash; <img src="../assets/images/qq.png"> &ndash;&gt;-->
        <!--                  <div>QQ咨询1</div>-->
        <!--              </div>-->
        <!--          </a>-->
        <!--          <a href="tencent://message/?uin=776321295">-->
        <!--              <div class="qq" style="border-top:none">-->
        <!--                  &lt;!&ndash; <img src="../assets/images/qq.png"> &ndash;&gt;-->
        <!--                  <div>QQ咨询2</div>-->
        <!--              </div>-->
        <!--          </a>-->
        <!--      </div>-->
        <div class="up" id="up" @click="upClick">
            <i class="el-icon-arrow-up"></i><br>
        </div>
        <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=1540156463&site=qq&menu=yes" class="qq"><img border="0"
                                                                                                   src="http://wpa.qq.com/pa?p=2:1540156463:53"
                                                                                                   alt="点击这里给我发消息"
                                                                                                   title="点击这里给我发消息"/></a>
        <div class="wechat">
            <img src="../assets/images/home/wechat_logo.png" class="logo">
            <div>添加微信</div>
            <img src="../assets/images/home/wechat.jpg" class="qrcode">
        </div>
    </div>
</template>

<script>
import Header from "./Header";
import Bottom from "./Bottom";

export default {
    name: "Index",
    components: {
        Header,
        Bottom
    },
    data() {
        return {
            timer: ''
        }
    },
    methods: {
        idxChange(__data) {
            this.$refs.aa.menuClick(__data);
        },
        upClick() {
            this.timer = setInterval(function () {
                window.scrollBy(0, -50);
            }, 10);
        },
        cheek() {
            let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
            if (top === 0) {
                clearInterval(this.timer);
            }
        },
        scroll() {
            let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
            if (top > 600) {
                document.getElementById('up').style.display = 'block';
            } else {
                document.getElementById('up').style.display = 'none';
            }
        }
    },
    created() {
        window.addEventListener('scroll', this.scroll);
        window.addEventListener('scroll', this.cheek);
    }
}
</script>

<style lang="scss" scoped>
.box {
    position: fixed;
    right: 0px;
    top: 50%;
    margin-top: -1.9rem;
    font-size: .12rem;
    z-index: 999;

    a {
        text-decoration: none;
    }

    div.qq {
        text-align: center;
        padding: .1rem .1rem .05rem .1rem;
        border: 1px solid #e0e0e0;
        border-right: none;
        color: #333;
        line-height: .22rem;

        img {
            width: .24rem;
            height: .25rem;
        }
    }
}

div.up {
    position: fixed;
    right: 8px;
    bottom: 1.5rem;
    width: .4rem;
    height: .4rem;
    text-align: center;
    padding-top: .05rem;
    background: #E70F20;
    display: none;

    i {
        color: #fff;
        font-size: .28rem;
    }
}

.qq {
    position: fixed;
    right: 3px;
    top: 56%;
    z-index: 999;
}

.wechat {
    position: fixed;
    right: 3px;
    top: 75%;
    width: 95px;
    height: 120px;
    background: #AFE2FC;
    border: 1px solid #9EC6D8;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    z-index: 999;
    cursor: pointer;
    font-size: 12px;

    &:hover {
        .qrcode {
            display: block;
        }
    }


    .logo {
        width: 70px;
        margin-bottom: 10px;
    }

    .qrcode {
        width: 200px;
        height: 200px;
        position: fixed;
        right: 100px;
        top: 75%;
        display: none;
    }
}
</style>

